/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, Grid, makeStyles, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { Cancel, Delete } from '@material-ui/icons';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import {
  ClientSessionsFields,
  ListClientDataSessionProps,
} from 'modules/clients/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import { formatDateWithMoment } from 'utils/helpers';
import {
  getSessionsClientsRequest,
  removeSessionsRequest,
} from 'modules/clients/actions';
import RefreshButton from 'components/RefreshButton';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { SearchBar } from 'components/SearchBar';
import { useTableFilters } from 'hooks/useTableFilters';
import { TableCellHeaderProps } from 'components/TableItems/interfaces';
import ScreenState from '../ScreenState';
import styles from './styles';
import FormRemoveSession from '../FormRemoveSession';

const useStyles = makeStyles(styles);

interface SessionContainerProps {
  isLoading: boolean;
  listSessionClients: ListClientDataSessionProps;
  getSessionsClientsRequest: (props) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  removeSessionsRequest: ({ values, query, id }) => void;
}

const SessionContainer: React.FC<SessionContainerProps> = ({
  isLoading,
  listSessionClients,
  getSessionsClientsRequest,
  modalOpen,
  modalClose,
  removeSessionsRequest,
}) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const {
    itemOrder,
    query,
    handleLimitChange,
    handleOrder,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters();

  const headersSession: TableCellHeaderProps[] = [
    {
      key: 'user__nome',
      i18n: 'NAME_KEY',
      order: true,
      centerTitle: false,
    },
    {
      key: 'user__email',
      i18n: 'EMAIL_KEY',
      order: true,
      centerTitle: false,
    },
    {
      key: 'instance__ec2_instance_id',
      i18n: 'INSTANCE_KEY',
      order: true,
      centerTitle: false,
    },
    {
      key: 'creation_date',
      i18n: 'CREATION_DATE_KEY',
      order: true,
      centerTitle: true,
    },
    {
      key: 'status',
      i18n: 'STATUS_KEY',
      order: true,
      centerTitle: true,
    },
    {
      key: 'actions',
      i18n: 'ACTIONS_KEY',
      order: false,
      centerTitle: true,
    },
  ];

  const [checks, setChecks] = React.useState<string[]>([]);
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);

  const getSessionClients = (refresh = false) => {
    getSessionsClientsRequest({ id, query });
    setRefresh(refresh);
  };

  React.useEffect(() => {
    getSessionClients();
  }, [getSessionsClientsRequest, query]);

  const handleAllCheck = () => {
    if (!selectedAll) {
      const ids: string[] = [];
      listSessionClients.results.forEach(item => {
        if (!['close', 'removing'].includes(item?.status)) {
          ids.push(item?.session_id);
        }
      });

      setChecks(ids);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleCheck = (uuid: string) => {
    const findCheckId = checks?.find(item => item === uuid);
    if (!findCheckId) {
      setChecks([...checks, uuid]);
    } else {
      const index = checks?.indexOf(findCheckId);
      checks.splice(index, 1);
      setChecks([...checks]);
    }
  };

  const handleDeleteSessions = (sessions: any[], type: string) => {
    let title = i18n.t('CLIENTS_PAGE.REMOVE_MULTIPLE_SESSIONS_TITLE_KEY');
    let subtitle = i18n.t(
      'CLIENTS_PAGE.REMOVE_MULTIPLE_SESSIONS_DESCRIPTION_KEY'
    );
    if (type !== 'multiple') {
      title = i18n.t('REMOVE_SESSION_KEY');
      subtitle = i18n.t('WANT_REMOVE_SESSION_MSG_KEY', {
        name: `${sessions[0].user?.first_name} ${sessions[0].user?.last_name}`,
      });
    }

    modalOpen({
      title,
      subtitle,
      content: (
        <FormRemoveSession
          onCancel={modalClose}
          onSubmit={(values: any) => {
            removeSessionsRequest({
              id,
              query,
              values: {
                ...values,
                sessions_ids: sessions?.map(({ session_id }) => session_id),
              },
            });
          }}
        />
      ),
      maxWidth: 'sm',
    });
  };

  return (
    <Grid>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} style={{ textAlign: 'end' }}>
          <RefreshButton
            id="btn-refresh"
            animate={isLoading}
            disabled={isLoading}
            onClick={() => getSessionClients()}
          />
          <Button
            id="remove-session-bulk-client-button"
            variant="contained"
            color="inherit"
            size="small"
            className={classes.removeButton}
            startIcon={<Delete />}
            onClick={() =>
              handleDeleteSessions(
                checks.map(item => ({ session_id: item })),
                'multiple'
              )
            }
            disabled={checks.length === 0}
          >
            {i18n.t('REMOVE_SESSIONS_KEY')}
          </Button>
        </Grid>
        <Grid item xs={5}>
          <SearchBar
            id="search-sessions"
            isLoading={isLoading}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
          />
        </Grid>
      </Grid>
      <TableItems
        header={
          <>
            <TableCell className={classes.checkboxCell}>
              <Checkbox
                onChange={handleAllCheck}
                id="select-all-session-clients"
              />
            </TableCell>
            {headersSession.map(item => (
              <TableCell
                key={item?.i18n}
                centerTitle={item?.centerTitle}
                className={classes.tableHeader}
                handleOrder={() => (item?.order ? handleOrder(item.key) : null)}
                order={item?.order}
                markOderItem={itemOrder === item.key}
              >
                {i18n.t(item?.i18n)}
              </TableCell>
            ))}
          </>
        }
        renderItems={(item: ClientSessionsFields) => (
          <TableRow key={item?.session_id} className={classes.rowHeight}>
            <TableCell className={classes.checkboxCell}>
              <Checkbox
                disabled={['close', 'removing'].includes(item?.status)}
                onChange={() => handleCheck(item?.session_id)}
                checked={!!checks?.find(check => check === item?.session_id)}
                id="select-session-clients"
              />
            </TableCell>
            <TableCell>
              {item?.user.first_name} {item?.user.last_name}
            </TableCell>
            <TableCell>{item?.user.email}</TableCell>
            <TableCell ellipsis maxLength={20} tooltip={item?.instance_id}>
              {item?.instance_id ? (
                <Link
                  className={classes.linkToInstances}
                  to={`/environments/${item?.environment_uuid}/instances?id=${item?.instance_id}`}
                >
                  {item?.instance_id}
                </Link>
              ) : (
                <Tooltip
                  title={i18n.t('CLIENTS_PAGE.USER_NO_LINKED_INSTANCE_KEY')}
                  placement="top"
                >
                  <Cancel className={classes.iconCancel} />
                </Tooltip>
              )}
            </TableCell>
            <TableCell className={classes.dateCell}>
              {formatDateWithMoment(item?.login_at)}
            </TableCell>
            <TableCell align="center">
              <Tooltip
                style={{ fontSize: 50 }}
                title={item?.status}
                placement="top"
              >
                <ScreenState
                  type={item?.status}
                  gridProps={{ justify: 'center' }}
                />
              </Tooltip>
            </TableCell>
            <TableCell align="center">
              <Tooltip title={i18n.t('REMOVE_SESSION_KEY')} placement="top">
                <IconButton
                  disabled={['close', 'removing'].includes(item?.status)}
                  onClick={() => handleDeleteSessions([item], 'single')}
                  id="remove-session-client-button"
                  className={classes.ButtonContainer}
                >
                  <Delete className={classes.icon} />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        )}
        data={listSessionClients}
        isLoading={!refresh && isLoading}
        onChangePage={handlePageChange}
        onChangeLimit={handleLimitChange}
        notFoundText={i18n.t('CLIENTS_PAGE.NO_SESSIONS_KEY')}
      />
    </Grid>
  );
};

const mapStateToProps = ({
  clients: { isLoading, listSessionClients },
}: ApplicationState) => ({
  isLoading,
  listSessionClients,
});

export default connect(mapStateToProps, {
  getSessionsClientsRequest,
  removeSessionsRequest,
  modalOpen,
  modalClose,
})(SessionContainer);
